import React from 'react';
import Icon from '@common/assets';
import styles from '@components/profile/profileOverlay/overlays/career/career.module.scss';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface WriteTextProps {
  type: 'required' | 'verified';
  text: string;
}

const WriteText = ({ type, text }: WriteTextProps) => {
  const isVerified = type === 'verified';

  return (
    <div className={cx('writeTextArea')}>
      <span className={cx('writeText', { required: !isVerified })}>{text}</span>
      {isVerified && <Icon name={'verifiedLightFilled'} width={24} height={24} fill={Colors.C_GREEN_150} />}
    </div>
  );
};

export default WriteText;
